module.exports = __webpack_public_path__ + "static/media/ken_kralick.39dd9bed.png";